import type { PanderrSection } from "../types";
import { renderPanderrButton } from "../components/button";
import { renderSiteFieldAttribute } from "../components/site-binding";

function escapeHtml(value: string): string {
  return String(value || "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");
}

export function renderHeroSection(section: PanderrSection): string {
  const image = section.images?.[0];
  const buttons = section.buttons ?? [];

  return `
    <section
      class="panderr-section panderr-hero"
      data-panderr-section="hero"
      data-panderr-section-id="${escapeHtml(section.id)}"
    >
      <div class="panderr-shell-wide panderr-hero-grid">
        <div class="panderr-hero-content">
          ${
            section.eyebrow || section.eyebrowField
              ? `<p class="panderr-eyebrow"${renderSiteFieldAttribute(section.eyebrowField)}>${escapeHtml(section.eyebrow)}</p>`
              : ""
          }

          ${section.heading || section.headingField ? `<h1${renderSiteFieldAttribute(section.headingField)}>${escapeHtml(section.heading || "")}</h1>` : ""}

          ${
            section.body || section.bodyField
              ? `<p class="panderr-lead panderr-hero-lead"${renderSiteFieldAttribute(section.bodyField)}>${escapeHtml(section.body)}</p>`
              : ""
          }

          ${
            buttons.length
              ? `
                <div class="panderr-hero-actions">
                  ${buttons.map(renderPanderrButton).join("")}
                </div>
              `
              : ""
          }
        </div>

        ${
          image
            ? `
              <div class="panderr-hero-media" data-panderr-element="media">
                <img
                  class="panderr-image panderr-image-hero"
                  src="${escapeHtml(image.src)}"
                  alt="${escapeHtml(image.alt)}"
                  data-panderr-component="image"
                  data-panderr-image-role="hero"
                >
              </div>
            `
            : ""
        }
      </div>
    </section>
  `;
}

export function createHeroSectionCss(): string {
  return `
    .panderr-hero {
      padding-top: clamp(3rem, 6vw, 6rem);
      background: var(--panderr-color-background);
    }

    .panderr-hero-grid {
      display: grid;
      grid-template-columns:
        minmax(0, 0.9fr)
        minmax(0, 1.1fr);
      gap: clamp(2.5rem, 6vw, 6rem);
      align-items: center;
    }

    .panderr-hero-content {
      max-width: 680px;
    }

    .panderr-hero h1 {
      max-width: 12ch;
    }

    .panderr-hero-lead {
      margin-top: 1.5rem;
      max-width: 58ch;
    }

    .panderr-hero-actions {
      display: flex;
      flex-wrap: wrap;
      gap: 0.85rem;
      margin-top: 2rem;
    }

    .panderr-hero-media {
      overflow: hidden;
      border-radius: var(--panderr-radius-large);
      box-shadow: var(--panderr-shadow-card);
      background: var(--panderr-color-surface);
    }

    .panderr-hero-media img {
      width: 100%;
      height: 100%;
    }

    @media (max-width: 900px) {
      .panderr-hero-grid {
        grid-template-columns: 1fr;
      }

      .panderr-hero-content {
        max-width: 760px;
      }

      .panderr-hero h1 {
        max-width: none;
      }
    }

    @media (max-width: 600px) {
      .panderr-hero-actions {
        flex-direction: column;
        align-items: stretch;
      }

      .panderr-hero-actions .panderr-button {
        width: 100%;
      }
    }
  `;
}
